class NutritionFacts extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll(".nutrition-facts__group-button");
    this.nutritionFacts = this.querySelectorAll(".performance-facts");
    this.addButtonListeners();
  }

  addButtonListeners() {
    this.buttons.forEach((button) => {
      button.addEventListener("change", (evt) => {
        let selector = evt.target.getAttribute("data-id");
        this.select(selector);
      });
    });
  }

  select(selected) {
    this.nutritionFacts.forEach((fact) => {
      const element = fact.getAttribute("data-id");
      if (element === selected) {
        fact.classList.add("performance-facts__is-selected");
      } else {
        fact.classList.remove("performance-facts__is-selected");
      }
    });
  }
}

customElements.define("nutrition-facts", NutritionFacts);

document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".nutrition-facts--section");
  const productSection = document.querySelector(".product-nf-section");
  const bgImage = document.querySelector(".mut-nf-texture-background-image");
  const hardcoreImage = document.querySelector(".nf-hardcore-image");

  if (!section || !bgImage || !hardcoreImage) {
    console.warn("Parallax elements not found");
    return;
  }

  const settings = {
    backgroundSpeed: -0.3,
    hardcoreSpeed: -0.5,
    hardcoreMaxScale: 1,
  };

  let sectionRect = section.getBoundingClientRect();
  let lastScrollY = window.scrollY;
  let ticking = false;

  function updateParallax() {
    // Get section's position relative to the viewport
    sectionRect = section.getBoundingClientRect();

    // Calculate viewport and visibility metrics
    const viewportHeight = window.innerHeight;
    const sectionVisibleHeight =
      Math.min(sectionRect.bottom, viewportHeight) -
      Math.max(sectionRect.top, 0);

    // Skip if section is not visible
    const sectionVisible =
      sectionVisibleHeight > 0 &&
      sectionRect.top < viewportHeight &&
      sectionRect.bottom > 0;

    if (!sectionVisible) return;

    // Calculate normalized position for parallax effect (-1 to 1)
    // -1 when section entering viewport from bottom
    // 0 when section centered in viewport
    // 1 when section leaving viewport from top
    const sectionCenter = sectionRect.top + sectionRect.height / 2;
    const viewportCenter = viewportHeight / 2;
    const distanceFromCenter =
      (viewportCenter - sectionCenter) / viewportHeight;
    const normalizedPosition = Math.max(
      -1,
      Math.min(1, distanceFromCenter * 2)
    );

    // Apply parallax effect to background image - MOVES DOWN
    if (bgImage) {
      const yOffset =
        normalizedPosition *
        settings.backgroundSpeed *
        (sectionRect.height / 1);
      bgImage.style.transform = `translateY(-${yOffset}px)`;
    }

    // Apply parallax and scale effect to hardcore image - MOVES UP
    if (hardcoreImage) {
      const yOffset = normalizedPosition * -0.2 * (sectionRect.height / 2);

      // Scale increases as we approach the center of the viewport
      const scaleProgress = 1 - Math.abs(normalizedPosition);
      const scale = 1 + scaleProgress * (settings.hardcoreMaxScale - 1);

      hardcoreImage.style.transform = `translateY(${yOffset}px) scale(${scale})`;
    }

    ticking = false;
  }

  function onScroll() {
    lastScrollY = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateParallax();
        ticking = false;
      });
      ticking = true;
    }
  }

  // Add event listeners
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", () => {
    sectionRect = section.getBoundingClientRect();
    updateParallax();
  });

  // Set initial position
  updateParallax();

  // Expose a function to update parallax on section reload/editor events
  if (productSection) {
    productSection.updateParallax = updateParallax;
  }
});
